import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { Discount } from '../components/Discount.js';
import { useCartSettings } from '../../../context/CartSettings/context.js';

const DiscountContainer = ({ discount  })=>{
    const { currency , getLabel , locale  } = useIntl();
    const settings = useCartSettings();
    const labels = React.useMemo(()=>({
            discount: getLabel('cart.item.discount')
        })
    , [
        locale,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(Discount, {
        currency: currency,
        absoluteValue: discount.absoluteValue,
        relativeValue: settings.multiDiscountType ? discount.relativeValue : undefined,
        labels: labels
    });
};

export { DiscountContainer };
//# sourceMappingURL=DiscountContainer.js.map
